var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { TradeType, validateAndParseAddress } from '@uniswap/sdk-core';
import { utils } from 'ethers';
import { toHex } from '../../../../../Fct/plugins/uniswap/helpers/getSwapCall/toHex';
import invariant from 'tiny-invariant';
var ZERO_HEX = '0x0';
export var getV3SwapCallParamsFromTrade = function (trade, options) {
    !(!('ttl' in options) || options.ttl > 0) ? invariant(false, 'TTL') : void 0;
    var recipient = validateAndParseAddress(options.recipient);
    var amountIn = toHex(trade.maximumAmountIn(options.allowedSlippage));
    var amountOut = toHex(trade.minimumAmountOut(options.allowedSlippage));
    // If there is only one pool in the route, we use ExactInputSingle
    if (trade.routes[0].pools.length === 1) {
        var route = trade.routes[0];
        var pool = route.pools[0];
        var tokenIn = route.input.address;
        var tokenOut = route.output.address;
        if (trade.tradeType === TradeType.EXACT_INPUT) {
            var paramsExactInputSingle = {
                params_tuple: {
                    tokenIn: tokenIn,
                    tokenOut: tokenOut,
                    fee: pool.fee,
                    recipient: recipient,
                    amountIn: amountIn,
                    amountOutMinimum: amountOut,
                    // This sqrtPriceLimitX96 value is what 1inch uses inside their swapper contract
                    // sqrtPriceLimitX96: BigInt(4295128739 + 1).toString(),
                    // Uniswap by default uses "0" as the sqrtPriceLimitX96
                    sqrtPriceLimitX96: '0',
                },
            };
            return {
                params: paramsExactInputSingle,
                value: ZERO_HEX,
            };
        }
        var paramsExactOutputSingle = {
            params_tuple: {
                tokenIn: tokenIn,
                tokenOut: tokenOut,
                fee: pool.fee,
                recipient: recipient,
                amountOut: amountOut,
                amountInMaximum: amountIn,
                // This sqrtPriceLimitX96 value is what 1inch uses inside their swapper contract
                // sqrtPriceLimitX96: (BigInt('1461446703485210103287273052203988822378723970342') - BigInt(1)).toString(),
                // Uniswap by default uses "0" as the sqrtPriceLimitX96
                sqrtPriceLimitX96: '0',
            },
        };
        return {
            params: paramsExactOutputSingle,
            value: ZERO_HEX,
        };
    }
    var types = trade.routes[0].path.reduce(function (acc, token, index) {
        if (index === trade.routes[0].path.length - 1) {
            return __spreadArray(__spreadArray([], __read(acc), false), ['address'], false);
        }
        return __spreadArray(__spreadArray([], __read(acc), false), ['address', 'uint24'], false);
    }, []);
    var values = trade.routes[0].path.reduce(function (acc, token, index) {
        if (index === trade.routes[0].path.length - 1) {
            return __spreadArray(__spreadArray([], __read(acc), false), [token.address], false);
        }
        var pool = trade.routes[0].pools[index];
        return __spreadArray(__spreadArray([], __read(acc), false), [token.address, pool.fee.toString()], false);
    }, []);
    if (trade.tradeType === TradeType.EXACT_INPUT) {
        var paramsExactInput = {
            params_tuple: {
                path: utils.solidityPack(types, values),
                recipient: recipient,
                amountIn: amountIn,
                amountOutMinimum: amountOut,
            },
        };
        return {
            params: paramsExactInput,
            value: ZERO_HEX,
        };
    }
    var paramsExactOutput = {
        params_tuple: {
            path: utils.solidityPack(types, values.reverse()),
            recipient: recipient,
            amountOut: amountOut,
            amountInMaximum: amountIn,
        },
    };
    return {
        params: paramsExactOutput,
        value: ZERO_HEX,
    };
};
